(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["novidades-spotlight"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scentory-spotlight')) {
    customElements.define('scentory-spotlight', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.viewport = this.querySelector('.nv-spotlight__viewport');
        this.track = this.querySelector('.nv-spotlight__track');
        this.originals = Array.from(this.track.children);
        this.total = this.originals.length;
        if (!this.total) return;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true';
        this.pauseButton = this.querySelector('[data-pause]');
        this.counter = this.querySelector('.nv-spotlight__counter');
        this.dots = Array.from(this.querySelectorAll('[data-slide]'));
        if (this.total > 1) {
          const before = document.createDocumentFragment();
          const after = document.createDocumentFragment();
          this.originals.forEach(slide => { before.append(slide.cloneNode(true)); after.append(slide.cloneNode(true)); });
          this.track.prepend(before);
          this.track.append(after);
        }
        this.slides = Array.from(this.track.children);
        this.position = this.total > 1 ? this.total : 0;
        this.classList.add('is-enhanced');
        this.querySelector('.nv-spotlight__controls').hidden = this.total < 2;
        this.querySelector('[data-previous]').addEventListener('click', () => this.move(-1), { signal });
        this.querySelector('[data-next]').addEventListener('click', () => this.move(1), { signal });
        this.dots.forEach(button => button.addEventListener('click', () => this.go(this.total + Number(button.dataset.slide)), { signal }));
        this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; this.updatePause(); this.restart(); }, { signal });
        this.addEventListener('pointerenter', () => { this.hovered = true; this.stop(); }, { signal });
        this.addEventListener('pointerleave', () => { this.hovered = false; this.restart(); }, { signal });
        this.addEventListener('focusin', event => { if (event.target.closest('a')) { this.linkFocused = true; this.stop(); } }, { signal });
        this.addEventListener('focusout', event => { if (event.target.closest('a')) { this.linkFocused = false; this.restart(); } }, { signal });
        this.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1);
        }, { signal });
        this.viewport.addEventListener('pointerdown', event => { if (event.button === 0) this.startPoint = { x: event.clientX, y: event.clientY }; }, { signal });
        this.viewport.addEventListener('pointercancel', () => { this.startPoint = null; }, { signal });
        this.viewport.addEventListener('pointerup', event => {
          if (!this.startPoint) return;
          const dx = event.clientX - this.startPoint.x;
          const dy = event.clientY - this.startPoint.y;
          this.startPoint = null;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
          this.ignoreClick = true;
          this.move(dx < 0 ? 1 : -1);
          setTimeout(() => { this.ignoreClick = false; }, 0);
        }, { signal });
        this.viewport.addEventListener('wheel', event => {
          const delta = event.shiftKey ? event.deltaY || event.deltaX : event.deltaX;
          if (!event.shiftKey && Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
          if (Math.abs(delta) < 4) return;
          event.preventDefault();
          if (Date.now() - (this.lastWheel || 0) < 500) return;
          this.lastWheel = Date.now(); this.move(delta > 0 ? 1 : -1);
        }, { signal, passive: false });
        this.track.addEventListener('click', event => {
          const slide = event.target.closest('.nv-spotlight__slide');
          if (!slide) return;
          if (this.ignoreClick) { event.preventDefault(); return; }
          const position = this.slides.indexOf(slide);
          if (position !== this.position) { event.preventDefault(); this.go(position); }
        }, { signal });
        document.addEventListener('visibilitychange', () => this.restart(), { signal });
        this.motion.addEventListener('change', () => this.restart(), { signal });
        this.resize = new ResizeObserver(() => this.center(false));
        this.resize.observe(this.viewport);
        this.visibility = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.restart(); }, { threshold: .15 });
        this.visibility.observe(this);
        this.updatePause();
        this.go(this.position, false);
      }
      logical(position) { return ((position % this.total) + this.total) % this.total; }
      center(animate = true) {
        const slide = this.slides[this.position];
        if (!slide) return;
        if (!animate) this.track.style.transition = 'none';
        this.track.style.transform = `translateX(${this.viewport.clientWidth / 2 - slide.offsetLeft - slide.offsetWidth / 2}px)`;
        if (!animate) { void this.track.offsetWidth; this.track.style.transition = ''; }
      }
      go(position, animate = true) {
        clearTimeout(this.normalizeTimer);
        this.position = Math.max(0, Math.min(this.slides.length - 1, position));
        this.slides.forEach((slide, index) => {
          const active = index === this.position;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.querySelectorAll('a,button').forEach(element => { element.tabIndex = active ? 0 : -1; });
        });
        const logical = this.logical(this.position);
        this.dots.forEach((button, index) => index === logical ? button.setAttribute('aria-current', 'true') : button.removeAttribute('aria-current'));
        this.counter.textContent = `${String(logical + 1).padStart(2, '0')} / ${this.total}`;
        this.center(animate);
        if (this.total > 1 && (this.position < this.total || this.position >= this.total * 2)) {
          this.normalizeTimer = setTimeout(() => this.go(this.total + logical, false), this.motion.matches ? 0 : 520);
        }
        this.restart();
      }
      move(direction) { if (this.total > 1) this.go(this.position + direction); }
      updatePause() {
        this.pauseButton.setAttribute('aria-pressed', String(this.paused));
        this.pauseButton.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      }
      stop() { clearInterval(this.timer); }
      restart() {
        this.stop();
        if (this.total < 2 || this.paused || this.dialogOpen || this.motion.matches || this.hovered || this.linkFocused || !this.visible || document.hidden) return;
        this.timer = setInterval(() => this.move(1), Number(this.dataset.interval || 5) * 1000);
      }
      disconnectedCallback() {
        this.stop(); clearTimeout(this.normalizeTimer); this.abort?.abort(); this.resize?.disconnect(); this.visibility?.disconnect();
        this.track?.replaceChildren(...this.originals); this.abort = null; this.classList.remove('is-enhanced');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
